import type { SalesResponse } from "../hooks/useGetSales";

/**
 * Minimal sales payload so invoice edit (allowEdit) can render totals and calculations
 * before / without a successful getSales response (e.g. advanced SOW with no hourly rate).
 */
export const EMPTY_SALES_RESPONSE: SalesResponse = {
  mainAreas: {
    areas: [],
    cost: 0,
    time: { minutes: 60, formatted: "1:00" },
  },
  otherAreas: {
    areas: [],
    cost: 0,
    time: { minutes: 0, formatted: "0:00" },
  },
  additionalObjects: {
    cost: 0,
    time: { minutes: 0, formatted: "0:00" },
  },
  specialRequests: 0,
  bufferTime: 0,
  increasePercentageByFrequency: 0,
  cost: 0,
  time: { minutes: 60, formatted: "1:00" },
};
